import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import BuyCatalogueList, { useBuyCatalogueList } from "../BuyCatalogueList";
import { Trans, useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import { useCheckout } from "../../providers/CheckoutProvider";
import CatalogueIcon from "../../../components/Icons/CatalogueIcon";
import { useAddToCartUseBuyNow } from "@/react/Webshop/hooks/useAddToCartUseBuyNow";

const useStyles = makeStyles((theme) => ({
  catalogueIconOuterContainer: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  catalogueIconContainer: {
    width: "100px",
    height: "85px",
    "& > svg": {
      display: "block",
    },
  },
  header: {
    color: theme.palette.primary.dark,
    margin: 0,
    textAlign: "center",
  },
}));

const UpsaleDialogCatalogue = ({ handleNextStep, catalogues }) => {
  const classes = useStyles();
  const { buyCatalogues } = useCheckout();
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const useBuyNow = useAddToCartUseBuyNow();

  useEffect(() => {
    setItems(
      (catalogues ?? []).map((c) => ({
        ...c,
        quantity: 0,
      })),
    );
  }, [catalogues]);

  const handleChange = (catatalogue) => (e) => {
    const nextQuantity = parseInt(e.target.value);
    setItems((prev) =>
      prev.map((c) => {
        if (c.uuid !== catatalogue.uuid) return c;
        const max = c.maxQuantity ?? Number.POSITIVE_INFINITY;
        const clamped = Math.max(0, Math.min(nextQuantity, max));
        return { ...c, quantity: clamped };
      }),
    );
  };

  const handleAddToCart = () => {
    const selected = items.filter((c) => c.quantity > 0);

    if (selected.length === 0) {
      alert(
        t(
          "You need to select how many cataloges you would like before clicking Add to shopping cart",
        ),
      );
      return;
    }

    buyCatalogues(selected).then(() => {
      handleNextStep();
    });
  };

  return (
    <Dialog open={true} fullWidth data-testid="special-offer-dialog">
      <DialogContent>
        <div className={classes.catalogueIconOuterContainer}>
          <div className={classes.catalogueIconContainer}>
            <CatalogueIcon color="primary" />
          </div>
        </div>
        <h2 className={classes.header}>
          <Trans>Don't forget the catalogue</Trans>
        </h2>

        {catalogues && (
          <BuyCatalogueList catalogues={items} handleChange={handleChange} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleNextStep} data-testid="decline-button">
          <Trans>No thanks</Trans>
        </Button>
        <Button color="primary" onClick={handleAddToCart}>
          {useBuyNow ? <Trans>Buy now</Trans> : <Trans>Add to cart</Trans>}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpsaleDialogCatalogue;
